import type { PolymorphicRef } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import type { ColumnComponent, ColumnProps } from '.';
import { StyledColumn } from '.';

export const Column: ColumnComponent = forwardRef(
  <C extends ElementType = 'div'>({ ...props }: ColumnProps<C>, ref: PolymorphicRef<C>) => {
    return <StyledColumn {...props} ref={ref} />;
  },
);
